<template>
	<div class="dis-fle">
		<div class="left">
			<div class="dis-fle ali-cen">
				<span class="txt-18">{{ title }}</span>
				<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" class="svg-class">
					<path
						d="M13 6.5C8.73438 6.5 4.63125 9.20156 3.25 13C4.63125 16.7984 8.73438 19.5 13 19.5C17.2453 19.5 21.3891 16.7984 22.7703 13C21.3688 9.20156 17.2453 6.5 13 6.5ZM13 17.0625C10.7656 17.0625 8.9375 15.2344 8.9375 13C8.9375 10.7656 10.7656 8.9375 13 8.9375C15.2344 8.9375 17.0625 10.7656 17.0625 13C17.0625 15.2344 15.2344 17.0625 13 17.0625ZM15.4375 13C15.4375 14.3406 14.3406 15.4375 13 15.4375C11.6594 15.4375 10.5625 14.3406 10.5625 13C10.5625 11.6594 11.6594 10.5625 13 10.5625C14.3406 10.5625 15.4375 11.6594 15.4375 13Z">
					</path>
				</svg>
			</div>
			<div class="top-info">
				<div class="left-con">
					<span class="balance">${{ data.total_money }}</span>
					<span class="txt-14">{{ data.unit }}</span>
				</div>
				<div class="right-con">
					<div class="operate-btn" @click="$nav.go('/pc/deposit')">
						<div class="svg-container" style="fill: rgb(85, 109, 234);">
							<svg data-v-cdcdc8fc="" width="16" height="16" viewBox="0 0 16 16"
								xmlns="http://www.w3.org/2000/svg" class="svg-class">
								<g data-v-cdcdc8fc="" id="Design tools / horizontal distribute center">
									<path data-v-cdcdc8fc="" id="Vector"
										d="M12.666 3.28594H12.0493V2.0026C12.0493 1.81253 11.9738 1.63025 11.8394 1.49584C11.705 1.36144 11.5228 1.28594 11.3327 1.28594C11.1426 1.28594 10.9603 1.36144 10.8259 1.49584C10.6915 1.63025 10.616 1.81253 10.616 2.0026V3.28594H9.99935C9.80928 3.28594 9.62699 3.36144 9.49259 3.49584C9.35819 3.63025 9.28268 3.81253 9.28268 4.0026V12.0026C9.28268 12.1927 9.35819 12.375 9.49259 12.5094C9.62699 12.6438 9.80928 12.7193 9.99935 12.7193H10.616V14.0026C10.616 14.1927 10.6915 14.375 10.8259 14.5094C10.9603 14.6438 11.1426 14.7193 11.3327 14.7193C11.5228 14.7193 11.705 14.6438 11.8394 14.5094C11.9738 14.375 12.0493 14.1927 12.0493 14.0026V12.7193H12.666C12.8561 12.7193 13.0384 12.6438 13.1728 12.5094C13.3072 12.375 13.3827 12.1927 13.3827 12.0026V4.0026C13.3827 3.81253 13.3072 3.63025 13.1728 3.49584C13.0384 3.36144 12.8561 3.28594 12.666 3.28594ZM10.716 11.2859V4.71927H11.9493V11.2859H10.716ZM7.33268 2.61927H6.04935V2.0026C6.04935 1.81253 5.97384 1.63025 5.83944 1.49584C5.70504 1.36144 5.52275 1.28594 5.33268 1.28594C5.14261 1.28594 4.96032 1.36144 4.82592 1.49584C4.69152 1.63025 4.61602 1.81253 4.61602 2.0026V2.61927H3.33268C3.14261 2.61927 2.96032 2.69478 2.82592 2.82918C2.69152 2.96358 2.61602 3.14587 2.61602 3.33594V12.6693C2.61602 12.8593 2.69152 13.0416 2.82592 13.176C2.96032 13.3104 3.14261 13.3859 3.33268 13.3859H4.61602V14.0026C4.61602 14.1927 4.69152 14.375 4.82592 14.5094C4.96032 14.6438 5.14261 14.7193 5.33268 14.7193C5.52275 14.7193 5.70504 14.6438 5.83944 14.5094C5.97384 14.375 6.04935 14.1927 6.04935 14.0026V13.3859H7.33268C7.52275 13.3859 7.70504 13.3104 7.83944 13.176C7.97384 13.0416 8.04935 12.8593 8.04935 12.6693V3.33594C8.04935 3.14587 7.97384 2.96358 7.83944 2.82918C7.70504 2.69478 7.52275 2.61927 7.33268 2.61927ZM4.04935 11.9526V4.0526H6.61602V11.9526H4.04935Z"
										stroke="white" stroke-width="0.1"></path>
								</g>
							</svg>
						</div>
						<span class="name">{{ $t('充值') }}</span>
					</div>
					<div class="operate-btn" @click="$nav.go('/pc/withdrawDeposit')">
						<span class="">{{ $t('提币') }}</span>
					</div>
					<div class="operate-btn" @click="$emit('goOrderTransfer')">{{ $t('划转') }}</div>
				</div>
			</div>

			<!-- <div class="select-div dis-fle ali-cen jus-bet">
				<el-input v-model="key" :placeholder="$t('搜索')" size="medium" prefix-icon="el-icon-search" clearable
					@change="getdata" style="width: 400px;"></el-input>

				<el-checkbox v-model="checked" @change="getdata">
					<span style="color: #606266;">{{ $t(`隐藏金额&lt; 1USD的币种`) }}</span>
				</el-checkbox>
			</div>

			<tableMode :list="accountInfo"></tableMode> -->
		</div>
		<div class="right">
			<div class="title">{{ $t('资产动态') }}</div>
			<zcTable :list="walletLog"></zcTable>
			<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
				:total="page.total" @current-change="getdata" />
		</div>
	</div>
</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api'
// import tableMode from './table.vue';
import zcTable from '../zcTable.vue';
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		// tableMode,
		oPage,
		zcTable
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		account: {
			type: Number,
			default: 1
		},
	},
	data() {
		return {
			key: '',
			checked: false,

			data: {},
			accountInfo: [],
			walletLog: [],

			page: {
				page: 1,
				limit: 13,
				total: 10,
			},
		};
	},
	methods: {

		init() {
			this.getdata()
		},
		getdata() {
			get(apis.getLegalData, {
				// account: this.account,
				// key: this.key,
				// hidden: this.checked ? 1 : 0,
				...this.page
			}).then(res => {
				if (res.code != 1) return
				this.data = res.data
				// this.accountInfo = res.data.account_info.slice(1)
				this.walletLog = res.data.wallet_log || []
				this.page.total = res.data.total || 10
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.left {
	margin-right: 30px;
	border-radius: 12px;
	border: 2px solid #2c2c3e;
	padding: 20px 30px;
	flex: 1;

	.select-div {
		padding: 20px 0px;
		border-top: 1px solid #31323f;
	}

	.top-info {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 20px;

		.right-con {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.operate-btn {
				width: 100px;
				height: 40px;
				line-height: 15px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 99px;
				border: 1px solid #84849f;
				margin-left: 10px;
				background: #000;
				font-size: 16px;
				text-align: center;
				cursor: pointer;

				.name {
					margin-left: 5px;
				}
			}
		}

		.left-con {
			position: relative;
			display: flex;
			align-items: center;

			.balance {
				font-size: 24px;
				margin-right: 10px;
			}
		}
	}
}

.right {
	width: 490px;
	height: 892px;
	overflow-y: auto;
	border-radius: 12px;
	border: 2px solid #2c2c3e;
	padding: 20px 30px;

	.title {
		// padding: 0 30px;
		height: 30px;
		line-height: 30px;
	}
}
</style>